import EL, { HTMLELEMENT } from '../../EL/EL.js';
import CODEBLOCK from '../../COMPONENT/codeblock/CODEBLOCK.js';
import CONTENT from '../../DOM/content/CONTENT.js';
import DIAGRAM from '../../COMPONENT/diagram/DIAGRAM.js';
import DIV, { div } from '../../DOM/div/DIV.js';
import HEADING from '../../DOM/heading/HEADING.js';
import TEXTBLOCK, { textBlock } from '../../DOM/div/TEXTBLOCK/TEXTBLOCK.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
// Model Structure
export const sectionAttr = makeAttrStruct([]);
export const sectionData = makeDataStruct([
    ['heading'],
    ['content']
]);
export const sectionModel = makeStruct([
    ['attributes', sectionAttr],
    ['data', sectionData]
]);
// Simplified Model
export function section(heading, content) {
    return {
        attributes: sectionAttr(),
        data: sectionData(heading, content)
    };
}
/** A generic SECTION */
export default class SECTION extends CONTENT {
    constructor(node, model) {
        super(node, HTMLELEMENT.SECTION, model);
        this.heading = new HEADING(this, model.data.heading);
        this.content = new CONTENT(this, HTMLELEMENT.DIV, model.data.content);
        this.addConstructor('DIV', this.addDiv.bind(this));
        this.addConstructor('SECTION', this.addSection.bind(this));
    }
    /** Adds a block of code wrapped in a PRE */
    addCodeBlock(model) {
        return this.addChild(new CODEBLOCK(this, model));
    }
    /** Adds a textblock and populates with the given markdown parsed as html */
    addDiagram(model) {
        return this.addChild(new DIAGRAM(this, model));
    }
    /** Adds a Div to this element */
    addDiv(model) {
        return this.addChild(new DIV(this, model));
    }
    /** Adds a Section to this element*/
    addSection(model) {
        return this.addChild(new SECTION(this, model));
    }
    /** Adds a block of text wrapped in a DIV */
    addTextblock(text) {
        const divElem = this.addDiv(div());
        let tb = divElem.addTextblock(textBlock(text));
        return tb;
    }
}
export { DIV, EL, TEXTBLOCK };
